import { useProfileContext } from "../contexts/ProfileContext";

/**
 * Per-user "workshop mode": the logged-in user has the hide-prices flag set
 * on their profile (e.g. a fitter at a vendor). Flagged users must not see
 * prices, commissions, or the cart anywhere - order screens stay usable as
 * work instructions only.
 */
export function useWorkshopMode(): boolean {
  const { workshopMode } = useProfileContext();
  return workshopMode;
}
